import { api } from './api';

export const carrierService = {
  /**
   * List carriers with optional filters
   * @param {Object} params - { status, type, limit, cursor, signal }
   */
  list: (params = {}) => {
    const { signal, ...queryParams } = params;
    return api.get('/carriers', { params: queryParams, signal });
  },

  /**
   * Get carrier by ID
   */
  getById: (id) => api.get(`/carriers/${id}`),

  /**
   * Create new carrier
   */
  create: (data) => api.post('/carriers', data),

  /**
   * Update carrier
   */
  update: (id, data) => api.put(`/carriers/${id}`, data),

  /**
   * Soft delete carrier
   */
  delete: (id) => api.delete(`/carriers/${id}`),

  /**
   * Activate carrier
   */
  activate: (id) => api.post(`/carriers/${id}/activate`),

  /**
   * Deactivate carrier
   */
  deactivate: (id) => api.post(`/carriers/${id}/deactivate`),
};
